// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TradeLink_trade__pms9c {
  background-color: #222121;
  border-radius: 8px;
}
.TradeLink_trade__pms9c .TradeLink_title__nS3Lf {
  font-size: 24px;
  font-weight: 600;
  align-items: center;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1490196078);
  color: #fff;
  display: flex;
  height: 55px;
  justify-content: space-between;
  padding-bottom: 16px;
  padding: 16px;
}
.TradeLink_trade__pms9c .TradeLink_title__nS3Lf .TradeLink_titleInfo__VKd-Z {
  align-items: center;
  display: flex;
  gap: 8px;
}
.TradeLink_trade__pms9c .TradeLink_title__nS3Lf .TradeLink_editBtn__gF6Yi {
  align-items: center;
  background-color: #333217;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 40px;
  transition: all 0.2s linear;
  width: 40px;
}
.TradeLink_trade__pms9c .TradeLink_title__nS3Lf .TradeLink_editBtn__gF6Yi:hover {
  background-color: #494711;
}
.TradeLink_trade__pms9c .TradeLink_txt__BdSgU {
  font-size: 16px;
  font-weight: 400;
  align-items: center;
  color: #EAD40C;
  display: flex;
  gap: 10px;
}
.TradeLink_trade__pms9c .TradeLink_input__XRSSa {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 20px;
}
.TradeLink_trade__pms9c .TradeLink_input__XRSSa .TradeLink_subtitle__x\\+9Kz {
  margin-bottom: 12px;
}
.TradeLink_trade__pms9c .TradeLink_input__XRSSa .TradeLink_inputWrapper__9N8Q7 {
  align-items: center;
  background-color: rgba(220, 220, 220, 0.1019607843);
  border-radius: 8px;
  display: flex;
  height: 42px;
  padding-left: 12px;
}
.TradeLink_trade__pms9c .TradeLink_input__XRSSa .TradeLink_inputWrapper__9N8Q7 input {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  background-color: unset;
  border: unset;
  color: #E0E0E0;
  outline: none;
  width: 100%;
}
.TradeLink_trade__pms9c .TradeLink_input__XRSSa .TradeLink_inputWrapper__9N8Q7 input::placeholder {
  color: #E0E0E0;
}
.TradeLink_trade__pms9c .TradeLink_instruction__yqZWV {
  font-size: 13px;
  font-weight: 600;
  color: #FFFFFF;
  cursor: pointer;
  margin-top: 16px;
}
.TradeLink_trade__pms9c .TradeLink_success__vrSBn {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  color: #fff;
  padding: 16px;
}
.TradeLink_trade__pms9c .TradeLink_success__vrSBn .TradeLink_attached__UWsZz {
  align-items: center;
  display: flex;
  gap: 4px;
  font-size: 16px;
  font-weight: 400;
}
.TradeLink_trade__pms9c .TradeLink_success__vrSBn .TradeLink_linkWrapper__71tcy {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: #E0E0E0;
  margin-top: 20px;
}
.TradeLink_trade__pms9c .TradeLink_success__vrSBn .TradeLink_linkWrapper__71tcy .TradeLink_link__rgtDt {
  background-color: rgba(220, 220, 220, 0.1019607843);
  border-radius: 8px;
  color: #FFFFFF;
  margin-top: 12px;
  padding: 18px 12px;
  word-wrap: break-word;
}
.TradeLink_trade__pms9c .TradeLink_btns__AxST2 {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.TradeLink_trade__pms9c .TradeLink_error__ZRltg {
  border: 1px solid #F44336;
}
.TradeLink_trade__pms9c .TradeLink_main__qACiU {
  padding: 16px;
}

@media (max-width: 850px) {
  .TradeLink_trade__pms9c {
    margin-bottom: 24px;
    width: 100%;
  }
  .TradeLink_trade__pms9c .TradeLink_title__nS3Lf {
    font-size: 20px;
  }
  .TradeLink_trade__pms9c .TradeLink_btns__AxST2 button {
    font-size: 14px;
    height: 36px;
    padding: 6px 16px;
    white-space: nowrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TradeLink/TradeLink.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,kBAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,0DAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;EACA,aAAA;AADJ;AAGI;EACE,mBAAA;EACA,aAAA;EACA,QAAA;AADN;AAII;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AAFN;AAIM;EACE,yBAAA;AAFR;AAOE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;AALJ;AAQE;EC6GA,eAAA;EACA,gBAAA;EACA,kBAAA;ED5GE,cAAA;EACA,gBAAA;AALJ;AAOI;EACE,mBAAA;AALN;AAQI;EACE,mBAAA;EACA,mDAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AANN;AAQM;EC2FJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED1FM,uBAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AALR;AAOQ;EACE,cAAA;AALV;AAWE;EACE,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,eAAA;EACA,gBAAA;AAVJ;AAaE;EClDA,eAAA;EACA,gBAAA;EACA,kBAAA;EDmDE,WAAA;EACA,aAAA;AAVJ;AAYI;EACE,mBAAA;EACA,aAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;AAVN;AAaI;ECoDF,eAAA;EACA,gBAAA;EACA,kBAAA;EDnDI,cAAA;EACA,gBAAA;AAVN;AAYM;EACE,mDAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAVR;AAeE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AAbJ;AAgBE;EACE,yBAAA;AAdJ;AAiBE;EACE,aAAA;AAfJ;;AAmBA;EACE;IACE,mBAAA;IACA,WAAA;EAhBF;EAkBE;IACE,eAAA;EAhBJ;EAqBI;IACE,eAAA;IACA,YAAA;IACA,iBAAA;IACA,mBAAA;EAnBN;AACF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.trade {\n  background-color: #222121;\n  border-radius: 8px;\n\n  .title {\n    font-size: 24px;\n    font-weight: 600;\n    align-items: center;\n    border-bottom: 1px solid #DCDCDC26;\n    color: #fff;\n    display: flex;\n    height: 55px;\n    justify-content: space-between;\n    padding-bottom: 16px;\n    padding: 16px;\n\n    .titleInfo {\n      align-items: center;\n      display: flex;\n      gap: 8px;\n    }\n\n    .editBtn {\n      align-items: center;\n      background-color: #333217;\n      border-radius: 8px;\n      cursor: pointer; \n      display: flex;\n      justify-content: center;\n      height: 40px;\n      transition: all .2s linear;\n      width: 40px;\n\n      &:hover {\n        background-color: #494711;\n      }\n    }\n  }\n\n  .txt {\n    font-size: 16px;\n    font-weight: 400;\n    align-items: center;\n    color: #EAD40C;\n    display: flex;\n    gap: 10px;\n  }\n\n  .input {\n    @include body1;\n\n    color: #E0E0E0;\n    margin-top: 20px;\n\n    .subtitle {\n      margin-bottom: 12px;\n    }\n\n    .inputWrapper {\n      align-items: center;\n      background-color: #DCDCDC1A;\n      border-radius: 8px;\n      display: flex;\n      height: 42px;\n      padding-left: 12px;\n\n      input {\n        @include body1;\n\n        background-color: unset;\n        border: unset;\n        color: #E0E0E0;\n        outline: none;\n        width: 100%;\n\n        &::placeholder {\n          color: #E0E0E0;\n        }\n      }\n    }\n  }\n\n  .instruction {\n    font-size: 13px;\n    font-weight: 600;\n\n    color: #FFFFFF;\n    cursor: pointer;\n    margin-top: 16px;\n  }\n\n  .success {\n    @include subtitle5;\n\n    color: #fff;\n    padding: 16px;\n\n    .attached {\n      align-items: center;\n      display: flex;\n      gap: 4px;\n      font-size: 16px;\n      font-weight: 400;\n    }\n\n    .linkWrapper {\n      @include body1;\n\n      color: #E0E0E0;\n      margin-top: 20px;\n\n      .link {\n        background-color: #DCDCDC1A;\n        border-radius: 8px;\n        color: #FFFFFF;\n        margin-top: 12px;\n        padding: 18px 12px;\n        word-wrap: break-word;\n      }\n    }\n  }\n\n  .btns {\n    display: flex;\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .error {\n    border: 1px solid #F44336;\n  }\n\n  .main {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 850px) {\n  .trade {\n    margin-bottom: 24px;\n    width: 100%;\n\n    .title {\n      font-size: 20px;\n    }\n\n    .btns {\n\n      button {\n        font-size: 14px;\n        height: 36px;\n        padding: 6px 16px;\n        white-space: nowrap;\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trade": `TradeLink_trade__pms9c`,
	"title": `TradeLink_title__nS3Lf`,
	"titleInfo": `TradeLink_titleInfo__VKd-Z`,
	"editBtn": `TradeLink_editBtn__gF6Yi`,
	"txt": `TradeLink_txt__BdSgU`,
	"input": `TradeLink_input__XRSSa`,
	"subtitle": `TradeLink_subtitle__x+9Kz`,
	"inputWrapper": `TradeLink_inputWrapper__9N8Q7`,
	"instruction": `TradeLink_instruction__yqZWV`,
	"success": `TradeLink_success__vrSBn`,
	"attached": `TradeLink_attached__UWsZz`,
	"linkWrapper": `TradeLink_linkWrapper__71tcy`,
	"link": `TradeLink_link__rgtDt`,
	"btns": `TradeLink_btns__AxST2`,
	"error": `TradeLink_error__ZRltg`,
	"main": `TradeLink_main__qACiU`
};
export default ___CSS_LOADER_EXPORT___;
